/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, LogLevel } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        clientId: "",
        authority: "https://login.microsoftonline.com/{tenantId}",
        redirectUri: "/",
        postLogoutRedirectUri: '/'
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                       console.error(message);
                        return;
                    case LogLevel.Info:
                       console.info(message);
                        return;
                    case LogLevel.Verbose:
                       console.debug(message);
                        return;
                    case LogLevel.Warning:
                       console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};
export const loginRequest = {
    scopes: ["User.Read"]
};
export const apiRequest = {
    scopes: ["api://{clientId}/read_user_profile"]
};
export const graphConfig = {
    graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me"
};
